import axios from "axios";
import { useState } from "react";
import Swal from "sweetalert2";

const Branch = () => {
  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [contents, setContents] = useState<string>("");

  // const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    // setLoading(true);

    await axios
      .post("/api/branch", {
        name: name,
        phone: phone,
        address: address,
        contents: contents,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        // setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <section id="branch" className="relative w-full h-full bg-light mx-auto pt-14 lg:pt-28 xl:pt-36">
      <div className="px-[calc((100%-var(--container))/4)] ">
        <div className="flex gap-10 lg:flex-row lg:items-start justify-center flex-wrap-reverse lg:flex-nowrap">
          {/* Map with region badges */}
          <div data-aos="fade-left" className="mx-auto h-full w-auto shrink-0 lg:mx-0 lg:max-w-[30%] max-w-[100vw]">
            <div className="relative aspect-[42/61] w-full">
              <img src="/images/map.png" alt="전국지도" />
            </div>
          </div>

          {/* Right column: heading + form + woman photo */}
          <div className="flex flex-1 flex-col w-fit lg:-ml-16 z-10">
            <div className="flex flex-col items-center gap-4  mb-4 text-center sm:flex-row sm:items-start sm:text-left w-fit">
              <img
                src={"/images/favicon.png"}
                alt="바우하우스 BAUHAUS 로고"
                className="max-h-12 w-auto h-full shrink-0 md:max-h-14 lg:max-h-52"
              />
              <div>
                <p className="text-sm md:text-base lg:text-lg">얼마나 많은 지사들이 있나요?</p>
                <h2 className="leading-tight mb-2 font-light">
                  바우하우스 <span className="text-primary font-extrabold">전국 지사망</span>
                </h2>
                <p className="text-center text-xl sm:text-left md:text-2xl">
                  전국 지역 어디든지 <span className="font-bold text-primary">최소 1개 지사</span>는 있습니다!
                </p>
              </div>
            </div>

            <div className="w-full lg:ml-20">
              {/* Form card */}
              <div className="w-full max-w-xl rounded-2xl border-2 border-primary bg-white p-6 md:p-8">
                <h3 className=" font-light">바우하우스 전국 지사장 모집 안내</h3>
                <form className="mt-5 space-y-3" onSubmit={(e) => e.preventDefault()}>
                  <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <input
                      type="text"
                      value={name}
                      id="name2"
                      onChange={(e) => setName(e.target.value)}
                      placeholder="이름을 입력하세요"
                      className="rounded-md border border-gray-200 bg-gray-100 px-3 py-2.5 text-sm text-center placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
                    />
                    <input
                      type="tel"
                      value={phone}
                      id="phone2"
                      maxLength={11}
                      onChange={(e) => setPhone(e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1"))}
                      placeholder="연락처를 입력하세요"
                      className="rounded-md border border-gray-200 bg-gray-100 px-3 py-2.5 text-sm text-center placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
                    />
                  </div>
                  <input
                    type="text"
                    placeholder="지사 희망 지역을 작성해주세요"
                    id="address2"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className="w-full rounded-md border border-gray-200 bg-gray-100 px-3 py-2.5 text-center text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
                  />
                  <textarea
                    placeholder="내용을 입력해주세요"
                    name="contents"
                    id="contents"
                    onChange={(e) => setContents(e.target.value)}
                    rows={3}
                    className="w-full resize-none rounded-md border border-gray-200 bg-gray-100 px-3 py-2.5 text-center text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#F4791C]/40"
                  />
                  <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
                    <label className="col-span-1 flex items-center justify-center gap-2 text-sm sm:justify-start">
                      <input
                        type="checkbox"
                        className="h-4 w-4 rounded-full border-gray-300 text-primary focus:ring-primary -mt-1"
                      />
                      개인정보&nbsp;처리방침&nbsp;동의
                    </label>
                    <button
                      type="button"
                      onClick={handlerPostContact}
                      className="lg:col-span-2 w-full shrink-0 rounded-md bg-primary py-2.5 text-sm text-white transition-colors hover:bg-[#e0690f]"
                    >
                      무료 상담요청
                    </button>
                  </div>
                </form>
                <p className="mt-4 text-sm leading-relaxed lg:text-base">
                  · 문의 접수 후 지사 조건 및 관련내용을 유선으로 상담드립니다.
                  <br />· 포기하지 않는 열정 가득한 분들의 지원을 기다립니다.
                </p>
              </div>
            </div>
            {/* Woman photo */}
          </div>
          <div
            data-aos="fade-right"
            className="hidden shrink-0 overflow-hidden rounded-xl lg:block lg:max-w-[25%] z-0 absolute right-[calc((100%-var(--container))/2)] bottom-0"
          >
            <img src="/images/bannerIcon3.png" alt="바우하우스 직원모집" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Branch;
